import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { GeslachtIcon } from "../../atoms/icons/GeslachtIcon";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<"Male" | "Female" | null>;
export const Geslacht = (props: AllProps) => {
    const { t } = useTranslation('client');
    
    const formatGender = (gender: "Male" | "Female" | null) => {
        if (!gender) return '-';
        return t(`gender.${gender}`, gender);
    };

    return (<Caption {...props} caption={props.label || t('gender', 'Geslacht')} icon={<GeslachtIcon />}>
        {formatGender(props.value)}
    </Caption>)
}

